<template>
  <div class="content-type-selector" data-testid="content-type-selector">
    <label class="selector-label">Content Type</label>
    <div class="selector-group" role="radiogroup" aria-label="Content type">
      <button
        v-for="option in options"
        :key="option.value"
        type="button"
        role="radio"
        :aria-checked="modelValue === option.value"
        :class="['selector-option', { 'selector-option-active': modelValue === option.value }]"
        :disabled="disabled"
        :data-testid="`content-type-option-${option.value}`"
        @click="selectOption(option.value)"
      >
        {{ option.label }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CONTENT_TYPE_OPTIONS } from '../../constants';

interface Props {
  modelValue: string;
  disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
});

const emit = defineEmits<{
  'update:modelValue': [value: string];
}>();

const options = CONTENT_TYPE_OPTIONS;

const selectOption = (value: string) => {
  if (!props.disabled) {
    emit('update:modelValue', value);
  }
};
</script>

<style scoped>
.content-type-selector {
  @apply mb-5;
}

.selector-label {
  @apply block text-sm font-medium text-zinc-700 dark:text-zinc-300 mb-2;
}

.selector-group {
  @apply inline-flex rounded-lg p-0.5 bg-zinc-100 dark:bg-zinc-700;
}

.selector-option {
  @apply px-4 py-1.5 text-sm font-medium rounded-md transition-colors cursor-pointer
         text-zinc-700 dark:text-zinc-300
         hover:text-zinc-900 dark:hover:text-zinc-100;
  background: transparent;
  border: none;
}

.selector-option:disabled {
  @apply opacity-50 cursor-not-allowed;
}

.selector-option-active {
  @apply bg-blue-500 text-white shadow-sm
         hover:text-white;
}

.selector-option-active:disabled {
  @apply opacity-100;
}
</style>
